import { useEffect, useRef } from "react";
import * as journifyTrackingCarEvents from "../services/trackingCarEvents";

const toNumber = (v, def = 0) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : def;
};

const toString = (v, def = "") => (v === undefined || v === null ? def : String(v));


export default function useTrackAddShippingInfo({
    car,
    shippingTier,
    stepNum,
    currency = "SAR",
}) {
    const firedRef = useRef(false);

    useEffect(() => {
        // نرسل الحدث فقط عندما ينتقل المستخدم من الخطوة 2 (بيانات الشحن) إلى الخطوة 3
        if (!car || stepNum !== 3 || firedRef.current) return;

        firedRef.current = true;

        const item = {
            item_id: toString(car?.ProductID ?? car?.ProductTarget, ""),
            item_name: toString(car?.DescriptionEn ?? car["Type English"], ""),
            affiliation: "value",
            coupon: "value",
            discount: 0,
            index: 0,
            item_brand: toString(car?.brandEn, "value"),
            item_category: toString(car?.category, "value"),
            item_category2: toString(car?.Model, "value"),
            item_category3: toString(car?.category, "value"),
            item_category4: toString(car?.carGroupID, "value"),
            item_category5: toString(car?.type, "value"),
            item_variant: toString(car?.ColorDescriptionEn, "value"),
            price: toNumber(car?.NetSalePrice, 0),
            quantity: 1,
        };

        journifyTrackingCarEvents.trackAddShippingInfo([item], shippingTier, currency, item.price, "value");

    }, [car, stepNum, shippingTier, currency]);
}
